import { render } from "./AdminHeader.vue?vue&type=template&id=3b476437"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__